import React from 'react';

import Input from './WidgetInput';
import PropsEmail from './interfaces/PropsEmailInterface';

export default class Email extends Input<PropsEmail> {
    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(this.props.name, event.target.value, false);
    }
}
